import FilterProvider from 'components/tickets/FilterProvider';
import 'helpers/initFA';
import AppProvider from 'providers/AppProvider';
import AuthenticatedUserProvider from 'providers/AuthenticatedUserProvider';
import SelectedViewProvider from 'providers/SelectedViewProvider';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from 'routes';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <AppProvider>
    <AuthenticatedUserProvider>
      <FilterProvider>
        <SelectedViewProvider>
          <RouterProvider router={router} />
        </SelectedViewProvider>
      </FilterProvider>
    </AuthenticatedUserProvider>
  </AppProvider>
);
